import { fundraisingDetail } from './detail.service';
import { fundraisingProjectDonationsService } from './project-donations-detail.service';
import { fundraisingHandover } from './middleware-handover.service';
import { fundraisingSearchService } from './search.service';

export const apiServices = {
  fundraisingSearchService,
  fundraisingProjectDonationsService,
  fundraisingDetail,
  fundraisingHandover,
};
